<app-navbar></app-navbar>
<div class="container-flex">
    <div class="my-container">
        <div class="section-title-container">
            <div class="row">
                <h3 class="info-title">
                    Videos del PARLACEN
                    <button class="btn btn-success btn-sm ml-2" data-toggle="modal" data-target="#add-video">
                        Agregar
                    </button>
                    <button class="btn btn-success btn-sm ml-2" (click)="listarVideos()">
                        Refrescar tabla
                    </button>
                </h3>
                <button type="button" class="btn btn-outline-dark outline-leer-mas">
                    <a class="nav-link" routerLink="/inicio">Inicio</a>
                </button>
            </div>
        </div>
        <div class="section-body-container">
            <div class="m-5 p-5" *ngIf="!videos || !videos?.length">

            </div>
            <table class="video-table table table-striped table-borderless table-responsive table-hover"
                *ngIf="videos && videos?.length">
                <caption class="sr-only">Noticias del Parlamento Centroamericano</caption>
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Título</th>
                        <th scope="col">Description</th>
                        <th scope="col">video</th>
                        <th scope="col">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of videos | slice: (page - 1) * pageSize : (page - 1) * pageSize + pageSize; let i = index;"
                        class="info-text">
                        <th scope="row">{{ i + 1 }}</th>
                        <td>{{ item.title }}</td>
                        <td>{{ item.description }}</td>
                        <td class="text-sky-blue">
                            <a [href]="cleanURL('https://youtu.be/' + item.video)" target="blank">
                                {{ item.title }}
                                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-paperclip"
                                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                        d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z" />
                                </svg>
                            </a>
                        </td>
                        <td class="text-center d-flex">
                            <div class="mr-1">
                                <button class="btn btn-primary btn-sm mt-1" data-toggle="modal" data-target="#view-video"
                                    (click)="setVideo(item)">
                                    Ver
                                </button>
                            </div>
                            <div>
                                <button class="btn btn-danger btn-sm mt-1" data-toggle="modal"
                                    data-target="#delete-video" (click)="setVideo(item)">
                                    Eliminar
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <ngb-pagination class="d-flex justify-content-center" [collectionSize]="videos?.length" [(page)]="page"
                [boundaryLinks]="true" [pageSize]="pageSize" size="sm" [maxSize]="5" [rotate]="true"
                *ngIf="videos && videos?.length">
            </ngb-pagination>
        </div>
    </div>
</div>
<div class="text-center spinner-container" *ngIf="loading">
    <div class="spinner-border text-primary text-center" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>

<!-- Add Video ∆ Modal ∆ -->
<div class="modal fade" id="add-video" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="add-video-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #addVideo="ngForm" (submit)="agregarVideo()">
                <div class="modal-header text-center  p-4 bg-dark">
                    <h5 class="modal-title group-title w-100 text-white" id="add-video-title">
                        Agregar Video
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cleanVideo()">
                        <span aria-hidden="true" class="text-white">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    
                    <div class="form-group pb-4">
                        <label for="add-title" class="group-title pb-1">
                            Título
                            <small style="color: red;">*</small>
                        </label>
                        <input type="text" class="form-control" id="add-title" #title="ngModel"
                            [(ngModel)]="myVideo.title" name="title" required aria-required="true"
                            [readonly]="isSubmitting">
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-description" class="group-title pb-1">
                            Breve descripción
                            <small style="color: red;">*</small>
                        </label>
                        <textarea type="description" class="form-control" id="add-description" #description="ngModel"
                            [(ngModel)]="myVideo.description" name="description" required aria-required="true"
                            [readonly]="isSubmitting" rows="3">
                        </textarea>
                    </div> 
                    <div class="form-group pb-4">
                        <label for="add-title" class="group-title pb-1">
                            Video
                            <small style="color: red;">*</small>
                        </label>
                        <input type="text" class="form-control" id="add-video" #video="ngModel"
                            [(ngModel)]="myVideo.video" name="video" required aria-required="true"
                            [readonly]="isSubmitting">
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-year" class="group-title pb-1">
                            Año de Publicación
                            <small style="color: red;">*</small>
                        </label>
                        <input type="date" class="form-control" id="update-creationDate" #creationDate="ngModel"
                            [(ngModel)]="myVideo.creationDate" name="creationDate" required aria-required="true"
                            [readonly]="isSubmitting">
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-description" class="group-title pb-1">
                            Visible en la web
                            <small style="color: red;">*</small>
                        </label><br>
                        <input type="radio" [value]="'ACTIVO'" name="gender" [(ngModel)]="myVideo.status"> Sí
                        <input type="radio" [value]="'INACTIVO'" name="gender" [(ngModel)]="myVideo.status"> No
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cleanVideo()"
                        [disabled]="isSubmitting">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-primary" type="submit" [disabled]="isSubmitting">
                        Agregar Video
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- View Video ∆ Modal ∆ -->
<div class="modal fade" id="view-video" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="view-video-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header text-center  p-4 bg-dark">
                <h5 class="modal-title group-title w-100 text-white" id="view-video-title">
                    Ver Video
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cleanVideo()">
                    <span aria-hidden="true" class="text-white">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="form-group pb-4">
                    <label for="view-title" class="group-title pb-1">
                        Título
                    </label>
                    <input type="text" class="form-control" id="view-title" [value]="myVideo.title" readonly>
                </div>
                <div class="form-group pb-4">
                    <label for="view-year" class="group-title pb-1">
                        Año de Publicación
                    </label>
                    <input type="date" class="form-control" id="view-creationDate" [value]="myVideo.creationDate" readonly>
                </div>
                <div class="form-group pb-4" *ngIf="myVideo.description">
                    <label for="view-description" class="group-title pb-1">Breve descripción</label>
                    <textarea type="description" class="form-control" id="view-description" [value]="myVideo.description"
                        readonly rows="9">
                    </textarea>
                </div>
                <div class="form-group pb-4">
                    <label for="add-description" class="group-title pb-1">
                        Visible en la web
                        <small style="color: red;">*</small>
                    </label><br>
                    <input type="radio" [value]="'ACTIVO'" name="gender" [(ngModel)]="myVideo.status" disabled> Sí
                    <input type="radio" [value]="'INACTIVO'" name="gender" [(ngModel)]="myVideo.status" disabled> No
                </div>
                <div class="form-group pb-4 d-block">
                    <label class="group-title pb-1">
                        Archivo
                    </label>
                    <br>
                    <iframe [title]="myVideo.title" style="width:100%; height:500px;"
                        [src]="cleanURLResource('https://www.youtube.com/embed/'+myVideo.video)">
                    </iframe>
                    <br>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cleanVideo()">
                    Salir
                </button>
            </div>
        </div>
    </div>
</div>


<!-- Delete Video ∆ Modal ∆ -->
<div class="modal fade" id="delete-video" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="delete-video-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #deleteVideo="ngForm" (submit)="eliminarVideo()">
                <div class="modal-header text-center  p-4 bg-dark">
                    <h5 class="modal-title group-title w-100 text-white" id="delete-video-title">
                        Eliminar Video
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cleanVideo()">
                        <span aria-hidden="true" class="text-white">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group pb-4">
                        <label for="delete-title" class="group-title pb-1">
                            Título
                        </label>
                        <input type="text" class="form-control" id="delete-title" [value]="myVideo.title" readonly>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 text-center">
                            <p class="info-text">
                                ¿Está seguro de que desea eliminar este video?
                            </p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" (click)="cleanVideo()"
                        [disabled]="isDeleting">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-sm btn-danger" type="submit" [disabled]="isDeleting">
                        Eliminar
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>